/**
 * @generated SignedSource<<94f5891d21c88973f3a3950627c30d90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SwiperItem_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"usePeriodGroupValue_itemSearch">;
  readonly " $fragmentType": "SwiperItem_itemSearch";
};
export type SwiperItem_itemSearch$key = {
  readonly " $data"?: SwiperItem_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SwiperItem_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SwiperItem_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePeriodGroupValue_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "be7c1de0168f880801e8a515ee69d047";

export default node;
